import { registerMockAPI } from '~/mocks/mockApis';

import { useDownloadMutation } from '~/hooks/common';
import { axiosInstance, downloadBlobDataFile } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeGetSpecificationsParams } from '~/types/receive.types';

type TypeGetSpecificationsMutationParams = {
  ownerCode: string;
  ids: TypeGetSpecificationsParams['ids'];
};

const fetchSpecifications = async ({ ownerCode, ids }: TypeGetSpecificationsMutationParams): Promise<void> => {
  const response = await axiosInstance.get(
    `${API_ENDPOINT.RECEIVE.GET_RECEIVING_SPECIFICATIONS}/${ownerCode}/specifications?ids=${ids}`,
    {
      responseType: 'blob',
    }
  );

  downloadBlobDataFile(response);
};

/**
 * [입고관리 > 입고요청관리] 검수확인용 거래명세서 다운로드 Mutation Hook
 */
export const useGetSpecificationsMutation = () => {
  return useDownloadMutation(fetchSpecifications);
};

registerMockAPI<null>({
  method: 'get',
  endpoint: '/api-inbound/v1/3pl/receiving/:ownerCode/specifications',
  label: '입고/입고요청/명세서다운로드',
  scenarios: [
    { name: '정상 응답', response: null },
    {
      name: '서버 오류',
      response: { error: { message: '거래명세서 다운로드 중 오류가 발생했습니다.' } },
      status: 500,
    },
  ],
});
